// TourProvider.jsx
import React, { createContext, useContext, useState } from "react";
import Joyride from "react-joyride";

const TourContext = createContext();

export function TourProvider({ children }) {
  const [steps, setSteps] = useState([]);
  const [run, setRun] = useState(false); // Keep this to control tour dynamically

  return (
    <TourContext.Provider value={{ setSteps, setRun }}>
      {children}
      <Joyride
        steps={steps}
        run={run} // ✅ use the state
        continuous
        showProgress
        showSkipButton
        disableBeacon
        scrollToFirstStep
        styles={{
          beaconInner: {
            backgroundColor: "red",
          },
          beaconOuter: {
            borderColor: "red",
          },
          options: {
            zIndex: 10000,
          },
        }}
      />
    </TourContext.Provider>
  );
}

export const useTour = () => useContext(TourContext);
